import React, { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import Azulao from '../Azulão.png';
import AppContext from '../api/AppContext';
import ChangePasswordModal from '../components/ChangePasswordModal';

const Login = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [userData, setUserData] = useState(null);
  
  const navigate = useNavigate();
  const { login: loginFunction } = useContext(AppContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    if (login === '' || password === '') {
      setMessage('Por favor, preencha todos os campos.');
      setIsLoading(false);
      return;
    }

    try {
      const response = await loginFunction({ login, password });
      
      setMessage('Login bem-sucedido!');
      setUserData(response.data.user);
      
      if (response.data.user.firstLogin) {
        setShowChangePasswordModal(true);
      } else {
        redirectUser(response.data.user.role);
      }

    } catch (error) {
      setMessage('CPF/E-mail ou senha incorretos.');
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordChangeSuccess = () => {
    setMessage('Senha alterada com sucesso! Redirecionando...');
    setShowChangePasswordModal(false);
    
    if (userData) {
      setTimeout(() => {
        redirectUser(userData.role);
      }, 1500);
    }
  };

  const redirectUser = (role) => {
    switch (role) {
      case 'admin':
        navigate('/dashboard');
        break;
      case 'member':
        navigate('/member/dashboard');
        break;
      case 'staff':
        navigate('/staff/dashboard');
        break;
      default:
        navigate('/');
    }
  };

  const handleForgotPassword = () => {
    alert('Link de recuperação enviado para o e-mail cadastrado.');
  };

  // Nova lógica para determinar o tipo de input
  const getInputType = () => {
    // Se contém @, é email
    if (login.includes('@')) {
      return 'email';
    }
    
    // Se só tem números (ou está vazio), é CPF
    const onlyNumbers = /^\d*$/.test(login);
    if (onlyNumbers) {
      return 'text'; // Usamos text para CPF para evitar validação de email
    }
    
    // Se tem caracteres mas não é email, também é text
    return 'text';
  };

  // Nova lógica para placeholder e maxLength
  const getInputProps = () => {
    const hasAtSymbol = login.includes('@');
    const onlyNumbers = /^\d*$/.test(login);
    
    if (hasAtSymbol) {
      return {
        type: 'email',
        placeholder: 'exemplo@email.com',
        maxLength: undefined
      };
    } else if (onlyNumbers || login === '') {
      return {
        type: 'text',
        placeholder: 'Digite seu CPF',
        maxLength: 11
      };
    } else {
      return {
        type: 'text',
        placeholder: 'CPF ou e-mail',
        maxLength: undefined
      };
    }
  };

  const inputProps = getInputProps();

  return (
    <div style={styles.container}>
        <div style={styles.img}>
            <img
            src={Azulao}
            alt="Banner"
            style={styles.image}
            />
        </div>
      <div style={styles.card}>
        <h2 style={styles.title}>Entre no App Olympic Club</h2>

        <form style={styles.form} onSubmit={handleLogin}>
          <label style={styles.label}>CPF ou E-mail:</label>
          <input
            type={inputProps.type}
            placeholder={inputProps.placeholder}
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            style={styles.input}
            maxLength={inputProps.maxLength}
          />

          <label style={styles.label}>Senha:</label>
          <div style={styles.passwordWrapper}>
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.inputPassword}
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={styles.eyeIcon}
            >
              {showPassword ? '🙈' : '👁️'}
            </span>
          </div>

          <button 
            type="submit" 
            style={styles.button}
            disabled={isLoading}
          >
            {isLoading ? 'CARREGANDO...' : 'ENTRAR'}
          </button>
          <button
            type="button"
            onClick={handleForgotPassword}
            style={styles.forgot}
          >
            Esqueci minha senha
          </button>

          {message && <p style={styles.message}>{message}</p>}
        </form>

        <ChangePasswordModal
          isOpen={showChangePasswordModal}
          onClose={() => setShowChangePasswordModal(false)}
          onSuccess={handlePasswordChangeSuccess}
        />
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f3f5ff',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '22px',
  },
  img: {},
  card: {
    width: '340px',
    backgroundColor: '#f3f5ff',
    borderRadius: '20px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    padding: '20px',
    textAlign: 'center',
  },
  image: {
    width: '100%',
    height: '180px',
    objectFit: 'cover',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#1f3b7d',
    margin: '20px 0',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '10px',
    paddingTop: '10px',
  },
  label: {
    textAlign: 'left',
    fontSize: '14px',
    color: '#444',
    marginBottom: '-8px',
  },
  input: {
    height: '35px',
    borderRadius: '20px',
    border: '1px solid #ccc',
    padding: '0 12px',
    fontSize: '14px',
    outline: 'none',
  },
  passwordWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  inputPassword: {
    flex: 1,
    height: '35px',
    borderRadius: '20px',
    border: '1px solid #007bff',
    padding: '0 40px 0 12px',
    fontSize: '14px',
    outline: 'none',
  },
  eyeIcon: {
    position: 'absolute',
    right: '12px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  button: {
    marginTop: '10px',
    backgroundColor: '#2a89ff',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '10px',
    height: '40px',
    cursor: 'pointer',
    fontSize: '14px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
    marginTop: '20px',
  },
  forgot: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'red',
    fontSize: '14px',
    marginTop: '10px',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  message: {
    marginTop: '10px',
    fontSize: '14px',
    color: 'red',
  },
};

export default Login;